module.exports = __webpack_public_path__ + "img/analysis.fc047642.gif";